import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "customers list" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-warning text-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-1 mb-2" }, "No customers found", -1)
const _hoisted_4 = { class: "mb-1" }
const _hoisted_5 = {
  key: 1,
  class: "table table-hover"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { width: "7%" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Select")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, "Company"),
  /*#__PURE__*/_createElementVNode("th", null, "Branch"),
  /*#__PURE__*/_createElementVNode("th", null, "AC Client Code"),
  /*#__PURE__*/_createElementVNode("th", null, "Nominal Code"),
  /*#__PURE__*/_createElementVNode("th", null, "Region")
], -1)
const _hoisted_7 = { class: "align-middle" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]

import { computed, ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { Customer, Office, SMSTemplate } from '@/models';
import { sortCustomerList } from '@/utilities';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomersList',
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();
const searchQuery = ref(router.currentRoute.value.params.search);

const customers = computed((): Customer[] => store.getters['customers/list']);
const hasBlockingRequests = computed((): boolean => store.getters['app/hasBlockingRequests']);
const smsTemplate = computed((): SMSTemplate => store.getters['smstemplates/current']);
const offices = computed((): Office[] => store.getters['offices/getOffices']);

const sortedCustomers = computed(() => sortCustomerList(customers.value));

function addClient(id: string) {
  store.dispatch('smstemplates/addClient', id);
}

function removeClient(id: string) {
  store.dispatch('smstemplates/removeClient', id);
}

function selected(customer: Customer) {
  return smsTemplate.value.clients.includes(customer.id);
}

const select = (c: Customer) => {
  addClient(c.id);
}
const unselect = (c: Customer) => {
  let customer = selected(c);
  if (customer) removeClient(c.id);
}

const getRegion = (id: string) => {
  const office = offices.value.find(o => o.id === id);
  return office ? office.name : '';
}

onMounted(() => {
  store.dispatch('customers/getCustomers', { starts_with: searchQuery.value });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!customers.value.length && !hasBlockingRequests.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("p", _hoisted_4, [
            _createTextVNode(" beginning with “"),
            _createElementVNode("strong", null, _toDisplayString((_unref(route).params.search as string).toUpperCase()), 1),
            _createTextVNode("” ")
          ])
        ]))
      : (_openBlock(), _createElementBlock("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedCustomers.value, (customer) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: customer.id
              }, [
                _createElementVNode("td", _hoisted_7, [
                  (selected(customer))
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: "fas fa-check text-success fa-2x",
                        onClick: ($event: any) => (unselect(customer))
                      }, null, 8, _hoisted_8))
                    : (_openBlock(), _createElementBlock("i", {
                        key: 1,
                        class: "fas fa-check fa-2x",
                        onClick: ($event: any) => (select(customer))
                      }, null, 8, _hoisted_9))
                ]),
                _createElementVNode("td", null, _toDisplayString(customer.companyName), 1),
                _createElementVNode("td", null, _toDisplayString(customer.branchName), 1),
                _createElementVNode("td", null, _toDisplayString(customer.acClientCode), 1),
                _createElementVNode("td", null, _toDisplayString(customer.nominalCode), 1),
                _createElementVNode("td", null, _toDisplayString(getRegion(customer.office)), 1)
              ]))
            }), 128))
          ])
        ]))
  ]))
}
}

})